import * as React from 'react';

import Musthead from '@app/components/UI/MustHead/Musthead';
import RichText from '@app/components/UI/RichText/RichText';
import CardPhoto from '@app/components/UI/CardPhoto/CardPhoto';
import {
	aquamationContent,
	aquamationTitle,
	differenceContent,
	differenceTitle,
	howDoesContent,
	howDoesTitle,
	whatCanContent,
	whatCanTitle,
	videoSrc,
	whatIsContent, whatIsTitle
} from '@app/components/Pages/Services/Aftercare/Aquamation/AquamationContent';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

const Aquamation = () => {

	return (
		<div>
			<Musthead
				title={aquamationTitle}
				imageSrc={require('@app/content/aftercare-aquamation.jpg')}
			/>
			<RichText
				text={aquamationContent}
			/>
			<RichText
				title={whatIsTitle}
				text={whatIsContent}
			/>
			<CardPhoto imgURL={require('@app/content/aquamation.jpg')} title={<>&nbsp;</>} />

			<RichText
				title={howDoesTitle}
				text={howDoesContent}
			/>
			<RichText
				title={differenceTitle}
				text={differenceContent}
			/>
			<RichText
				title={whatCanTitle}
				text={whatCanContent}
			/>
			<VideoEmbed
				videoSrc={videoSrc}
			/>
		</div>
	);
};

export default withSeo(Aquamation, state => state.aquamationPage, 'aquamationPage', 'our-services/aftercare/aquamation');
